import safeExec from "@/shared/utils/safeExec";
import { fastRaf, throttleWith } from "./schedulars";

export type AnyToVoidFunction = (...args: any[]) => void;
export type NoneToVoidFunction = () => void;
let pendingMeasureTasks: NoneToVoidFunction[] = [];
let pendingMutationTasks: NoneToVoidFunction[] = [];
let pendingForceReflowTasks: (() => NoneToVoidFunction | void)[] = [];

const runUpdatePassOnRaf = throttleWithRafFallback(() => {
  const currentMeasureTasks = pendingMeasureTasks;
  pendingMeasureTasks = [];
  currentMeasureTasks.forEach((task) => {
    safeExec(task);
  });

  // We use promises to provide correct order for Mutation Observer callback microtasks
  Promise.resolve()
    .then(() => {
      const currentMutationTasks = pendingMutationTasks;
      pendingMutationTasks = [];

      currentMutationTasks.forEach((task) => {
        safeExec(task);
      });
    })
    .then(() => {
      const pendingForceReflowMutationTasks: NoneToVoidFunction[] = [];
      // Will include tasks created during the loop
      for (const task of pendingForceReflowTasks) {
        safeExec(() => {
          const mutationTask = task();
          if (mutationTask) {
            pendingForceReflowMutationTasks.push(mutationTask);
          }
        });
      }
      pendingForceReflowTasks = [];

      return pendingForceReflowMutationTasks;
    })
    .then((pendingForceReflowMutationTasks) => {
      // Will include tasks created during the loop
      for (const task of pendingForceReflowMutationTasks) {
        safeExec(task);
      }
    })
    .then(() => {});
});

export function requestMeasure(cb: NoneToVoidFunction) {
  pendingMeasureTasks.push(cb);
  runUpdatePassOnRaf();
}

export function requestMutation(cb: NoneToVoidFunction) {
  pendingMutationTasks.push(cb);
  runUpdatePassOnRaf();
}

export function requestNextMutation(cb: () => NoneToVoidFunction | void) {
  requestMeasure(() => {
    requestMutation(cb);
  });
}

export function requestForcedReflow(cb: () => NoneToVoidFunction | void) {
  pendingForceReflowTasks.push(cb);
  runUpdatePassOnRaf();
}

function throttleWithRafFallback<F extends AnyToVoidFunction>(fn: F) {
  // @ts-expect-error i know this
  return throttleWith((throttledFn: NoneToVoidFunction) => {
    fastRaf(throttledFn, true);
  }, fn);
}
